import { createSlice } from '@reduxjs/toolkit';

interface Role {
    id: number;
    name: string;
    slug: string;
}
  
interface SubMenu {
    id: number;
    name: string;
    slug: string;
    url: string;
    icon: string;
    permissions: string[];
    sub_menus: SubMenu[] | null;
}
  
interface Menu {
    id: number;
    name: string;
    slug: string;
    url: string;
    icon: string;
    permissions: string[];
    sub_menus: SubMenu[] | null;
}

interface permission{
    permissions:any,
    navigateTabsArray:Array<Object>,
    nestedPermissionsData:Array<Object>,
    getFilterPermissionsObject:any, 
    roles: Role[];
    menus: Menu[];
    moduleUrls:Array<string>,
}

const initialState:permission = {
    permissions:"",
    navigateTabsArray:[],
    nestedPermissionsData:[],
    getFilterPermissionsObject:{}, 
    roles: [],
    menus: [],
    moduleUrls: [],
};
const modalSlice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {
        setPermission: (state, action) => {
            return { ...state, isOpen: true, ...action.payload }
        },
        
    },
});
export const { setPermission } = modalSlice.actions;
export default modalSlice.reducer;